import React, { useState, useEffect } from "react";
import { MenuSelect, ProfileSelect } from "../components/Form";
import { TbHeartPlus, TbUser } from "react-icons/tb";
import {
  AiOutlineDollar,
  AiOutlineFileDone,
  AiOutlinePlusSquare,
  AiOutlinePoweroff,
  AiOutlineUser,
} from "react-icons/ai";
import { MdDrafts, MdOutlineNotificationsNone } from "react-icons/md";
import NotificationComp from "../components/NotificationComp";
import { useNavigate } from "react-router-dom";
import { BiChat, BiMenu, BiPlusCircle } from "react-icons/bi";
import MenuDrawer from "../components/Drawer/MenuDrawer";
import { BsBookmark, BsHeartArrow, BsHeartFill } from "react-icons/bs";
import { RiDraftLine } from "react-icons/ri";
import axios from "axios";
import { BaseUrl } from "../BaseUrl";

function Header() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [user, setUser] = useState(null);

  // Fetch user data on mount using /doctor/me (consistent with useAuth)
  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Use /doctor/me endpoint - same as useAuth hook
        const response = await axios.get(`${BaseUrl}/doctor/me`, {
          withCredentials: true,
        });

        if (response.data?.success && response.data?.data) {
          setUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        // Fallback to email from localStorage
        const userEmail = localStorage.getItem("email");
        if (userEmail) {
          setUser({ fullName: userEmail.split("@")[0] });
        }
      }
    };
    fetchUser();
  }, []);

  // Get display name - Alpha is Facility app, prioritize businessName
  const displayName =
    user?.businessName || user?.fullName || user?.name || "Facility";
  const userImage =
    user?.profileImage || user?.userImage || user?.image || user?.logo || null;
  const initials = displayName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  // toggle drawer
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const navigate = useNavigate();
  const DropDown1 = [
    {
      title: "Profile",
      icon: AiOutlineUser,
      onClick: () => {
        navigate("/hfr-facility");
      },
    },
    {
      title: "Logout",
      icon: AiOutlinePoweroff,
      onClick: () => {
        navigate("/");
      },
    },
  ];

  return (
    <>
      {isOpen && <MenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />}

      {/* cmp */}
      <div className='relative top-0 z-40 grid w-full grid-cols-12 items-center bg-dry bg-opacity-95 px-2 md:grid-cols-2 xl:w-5/6 2xl:max-w-[1640px]'>
        <div className='col-span-10 flex items-center gap-4 py-4 sm:col-span-11 md:col-span-1 md:py-0'>
          <button
            onClick={toggleDrawer}
            className='flex-colo transitions block h-12 w-16 rounded-md border bg-greyed text-2xl text-textGray hover:bg-border md:w-12 xl:hidden'
          >
            <BiMenu />
          </button>
        </div>
        <div className='col-span-2 items-center justify-end pr-4 sm:col-span-1 md:col-span-1 md:pr-0'>
          <div className='float-right flex items-center justify-center gap-4'>
            <NotificationComp>
              <div className='relative'>
                <MdOutlineNotificationsNone className='text-2xl hover:text-subMain' />
              </div>
            </NotificationComp>
            <div className='hidden items-center md:flex'>
              <ProfileSelect datas={DropDown1}>
                <div className='flex items-center gap-4 rounded-lg p-4'>
                  {userImage ? (
                    <img
                      src={userImage}
                      alt='user'
                      className='h-12 w-12 rounded-full border border-border object-cover'
                    />
                  ) : (
                    <div className='flex h-12 w-12 items-center justify-center rounded-full border border-border bg-[#0095D9] font-medium text-white'>
                      {initials}
                    </div>
                  )}
                  <p className='text-sm font-medium text-black'>
                    {displayName}
                  </p>
                </div>
              </ProfileSelect>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
